import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.75736 7.75736C6.10051 5.41421 9.8995 5.41421 12.2426 7.75736C13.1589 8.67365 13.7169 9.81257 13.9166 11H22V13H20.5V15H18.5V13H17.5V15.9985H15.5V13H13.9166C13.7169 14.1874 13.1589 15.3264 12.2426 16.2426C9.8995 18.5858 6.10051 18.5858 3.75736 16.2426C1.41421 13.8995 1.41421 10.1005 3.75736 7.75736Z"}}]};

const KeyFilled = Vue.extend<IconProps>({
  name: 'KeyFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'key-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default KeyFilled;
